import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { loadAir } from "./office/air";
import { loadAdamino } from "./office/adamino";
import { loadEolo } from "./office/eolo";
//import { loadLucky } from "./office/lucky";
import { loadMario } from "./office/mario";
import { loadPacman } from "./office/pacman";
import { loadServer } from "./office/server";
import { loadCoffeeMachine } from "./office/coffeemachine";
import { loadDrone } from "./office/drone";
//import { loadAndroid } from "./office/android";
import { loadSwitch2 } from "./office/switch2";
import { loadNas } from "./office/nas";
import { loadSonic } from "./office/sonic";
import { loadVr } from "./office/vr";
import { loadAroundWeb } from "./office/aroundweb";
import { loadMemes } from "./office/memes";
//import { loadMazinga2 } from "./office/mazinga2";
//import { loadDaitan3 } from "./office/daitan3";
//import { loadGoldrake } from "./office/goldrake";
//import { loadJeeg } from "./office/jeeg";
//import { loadKen } from "./office/ken";
//import { loadRyu } from "./office/ryu";
//import { loadBronzi } from "./office/bronzi";
import { loadBackWall } from "./office/backWall";
import { camera, controls } from "./office/camera";
import { loadChair } from "./office/chair";
import { loadCity } from "./office/city";
import { loadCodeWall1 } from "./office/codeWall1";
import { loadCodeWall1b } from "./office/codeWall1b";
import { loadHtml5 } from "./office/html5";
import { loadJoypad2 } from "./office/joypad2";
import { loadJs } from "./office/js";
import { loadMonitor } from "./office/monitor";
import { loadNeon } from "./office/neon";
import { loadNodeLogo } from "./office/nodeLogo";
import { loadOffice } from "./office/office";
import { loadPhp } from "./office/php";
import { loadPs4 } from "./office/ps4";
import { loadPs5 } from "./office/ps5";
//import { ControlFunction } from "./office/controlFunction";
import { loadReactLogo } from "./office/reactLogo";
import { renderer as initialRenderer } from "./office/renderer";
import { scene } from "./office/scene";
import { loadSwitch } from "./office/switch";
import { loadUrl } from "./office/url";
import { initInteractions } from "./office/interactions";

var texture_loader = new THREE.TextureLoader();
let shadow = true;
const shadowValue = localStorage.getItem("shadow");
if (shadowValue !== null) {
  if (shadowValue === "true") {
    shadow = true;
  } else {
    shadow = false;
  }
}
//import { loadCodeWall2 } from "./office/codeWall2";
import { loadCodeWall3 } from "./office/codeWall3";
//import { loadCodeWall4 } from "./office/codeWall4";
import { loadCodeWall5 } from "./office/codeWall5";
import { loadCodeWall6 } from "./office/codeWall6";
import { loadCoffee } from "./office/coffee";
import { loadCoinop } from "./office/coinop";
import { loadCoinopScreen } from "./office/coinop_screen";
import { loadDoor } from "./office/door";
import { loadElix } from "./office/elix";
import { loadFan } from "./office/fan";
import { loadFrontWall } from "./office/frontWall";
import { loadFrontWallDx } from "./office/frontWallDx";
import { loadFrontWallSx } from "./office/frontWallSx";
import { loadGuitar } from "./office/guitar";
import { loadHeadset } from "./office/headset";
import { loadJava } from "./office/java";
import { loadJoypad3b } from "./office/joypad3b";
import { loadKeyboard } from "./office/keyboard";
import { loadKeyboard2 } from "./office/keyboard2";
import { loadPaint1 } from "./office/paint1";
import { loadPaint2 } from "./office/paint2";
import { loadPaint3 } from "./office/paint3";
import { loadPaint4 } from "./office/paint4";
//import { loadPc } from "./office/pc";
import { loadPcPersonal } from "./office/pc_personal";
import { loadPendrive } from "./office/pendrive";
import { loadRoof } from "./office/roof";
import { loadScreen } from "./office/screen";
import { loadShelf } from "./office/shelf";
import { loadSkills } from "./office/skills";
import { loadSmartphone } from "./office/smartphone";
import { loadSofa } from "./office/sofa";
import { loadStand } from "./office/stand";
import { loadTapisRoulant } from "./office/tapis-roulant";
//import { loadWorld } from "./office/world";
//import { loadBeam } from "./office/beam";
import { loadNotebook } from "./office/notebook";
import { loadShelfAf } from "./office/shelf_af";
import { loadRealClock } from "./office/realClock";
import { loadScreenNotebook } from "./office/screenNotebook";
import { loadTv } from "./office/tv";
//import { loadTvstand2 } from "./office/tvstand2";
import { loadCoding } from "./office/coding";
import { loadDbLogo } from "./office/dblogo";
import { loadDbLogoPng } from "./office/dblogoPng";
import { loadDbLogoPngWhite } from "./office/dblogoPngWhite";
import { loadGlass } from "./office/glass";
import { loadSeriesX } from "./office/seriesx";
import { loadSky } from "./office/sky";
import { loadTask } from "./office/task";
import { loadXbox } from "./office/xbox";
//import gsap from "gsap";
import { clock } from "./office/clock";
import { keysCamera, enableFpsMode, disableFpsMode, isFpsMode } from "./office/keysCamera";
import { StartTimeline } from "./office/timeline";
import { XRControllerModelFactory } from "three/examples/jsm/webxr/XRControllerModelFactory.js";
import { initJoysticks } from "./office/joystick";
const loader = new GLTFLoader();
const elapsedTime = clock.getElapsedTime();

let modelPromises = [];

let renderer;
let lightPrimary;
let lightFill;
let lightRim;
let lightBounce;
let currentSet = "studio";
let brightnessLevel =
  Math.min(
    1.4,
    Math.max(
      0.6,
      parseFloat(localStorage.getItem("sceneBrightness")) || 1
    )
  );
const bloomEnabled = localStorage.getItem("bloom") === "true";
let vrSession = null;
let controllerGrip1;
let controllerGrip2;

function initVrControllers() {
  const controllerModelFactory = new XRControllerModelFactory();

  const controller1 = renderer.xr.getController(0);
  const controller2 = renderer.xr.getController(1);
  scene.add(controller1);
  scene.add(controller2);

  controllerGrip1 = renderer.xr.getControllerGrip(0);
  controllerGrip1.add(controllerModelFactory.createControllerModel(controllerGrip1));
  scene.add(controllerGrip1);

  controllerGrip2 = renderer.xr.getControllerGrip(1);
  controllerGrip2.add(controllerModelFactory.createControllerModel(controllerGrip2));
  scene.add(controllerGrip2);
}

const sceneSets = {
  studio: {
    background: 0x0e0e12,
    fog: { color: 0x0e0e12, near: 14, far: 45 },
    lights: {
      primary: { color: 0xffffff, intensity: 2.2 },
      fill: { color: 0xfaf0e6, intensity: 1.0 },
      rim: { color: 0xb4c8ff, intensity: 1.5 },
      bounce: { color: 0xd7d7d7, intensity: 0.9 },
    },
  },
  neon: {
    background: 0x08090f,
    fog: { color: 0x08090f, near: 10, far: 32 },
    lights: {
      primary: { color: 0x9cd7ff, intensity: 1.7 },
      fill: { color: 0xffcba4, intensity: 0.85 },
      rim: { color: 0x8ad7ff, intensity: 1.9 },
      bounce: { color: 0xa9a9a9, intensity: 0.8 },
    },
  },
  night: {
    background: 0x04050a,
    fog: { color: 0x04050a, near: 8, far: 22 },
    lights: {
      primary: { color: 0x9ac7ff, intensity: 0.6 },
      fill: { color: 0xffc2a3, intensity: 0.25 },
      rim: { color: 0x4a7dff, intensity: 0.7 },
      bounce: { color: 0x252525, intensity: 0.35 },
    },
  },
  dawn: {
    background: 0x0c1018,
    fog: { color: 0x0c1018, near: 10, far: 32 },
    lights: {
      primary: { color: 0xf9e0c7, intensity: 1.2 },
      fill: { color: 0xaed1ff, intensity: 0.65 },
      rim: { color: 0xffc78d, intensity: 1.0 },
      bounce: { color: 0x555555, intensity: 0.65 },
    },
  },
  warm: {
    background: 0x120c08,
    fog: { color: 0x120c08, near: 12, far: 34 },
    lights: {
      primary: { color: 0xffd9a0, intensity: 1.5 },
      fill: { color: 0xffb17a, intensity: 1.0 },
      rim: { color: 0xff9f6e, intensity: 0.85 },
      bounce: { color: 0xa47a5a, intensity: 0.7 },
    },
  },
  calm: {
    background: 0x0c0f12,
    fog: { color: 0x0c0f12, near: 12, far: 30 },
    lights: {
      primary: { color: 0xd8e6ff, intensity: 1.2 },
      fill: { color: 0x9dc5ff, intensity: 0.7 },
      rim: { color: 0x6eb4ff, intensity: 0.9 },
      bounce: { color: 0x555555, intensity: 0.65 },
    },
  },
};

const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

//config
const startTimeline = false;
const startKeysCamera = true;
const inputCamera = false;

if (!inputCamera) {
  document.querySelector(".positionDiv").style.display = "none";
}

//office
modelPromises.push(loadOffice());

//sofa
modelPromises.push(loadSofa());

//monitor
modelPromises.push(loadMonitor());
/*
modelPromises.push(loadMonitor().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Monitor";
  return m;
}));
*/

//react logo
modelPromises.push(loadReactLogo().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "React.js";
  return m;
}));

//node logo
modelPromises.push(loadNodeLogo().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Node.js";
  return m;
}));

//php
modelPromises.push(loadPhp().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "PHP";
  return m;
}));

//url
modelPromises.push(loadUrl());

//js
modelPromises.push(loadJs().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Javascript";
  return m;
}));

//html5
modelPromises.push(loadHtml5().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "HTML5";
  return m;
}));

//joypad
modelPromises.push(loadJoypad2().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Joypad";
  return m;
}));

modelPromises.push(loadJoypad3b().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Joypad";
  return m;
}));


//chair
modelPromises.push(loadChair().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Gaming chair";
  return m;
}));

//ps4
modelPromises.push(loadPs4().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Ps4";
  return m;
}));

//ps5
modelPromises.push(loadPs5().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Ps5";
  return m;
}));

//guitar
modelPromises.push(loadGuitar().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "BC Rich Warlock";
  return m;
}));

//coinop
modelPromises.push(loadCoinop().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Coinop SpaceInvaders";
  return m;
}));
modelPromises.push(loadCoinopScreen());

//vr
modelPromises.push(loadVr().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "VR";
  return m;
}));

//headset
modelPromises.push(loadHeadset().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Headset";
  return m;
}));

//pendrive
modelPromises.push(loadPendrive().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Pendrive";
  return m;
}));

//air
modelPromises.push(loadAir());

//adamino
modelPromises.push(loadAdamino().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Adam";
  return m;
}));

//eolo
modelPromises.push(loadEolo().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Eolo";
  return m;
}));

//lucky
//modelPromises.push(loadLucky());

//mario
modelPromises.push(loadMario().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Mario";
  return m;
}));

//pacman
modelPromises.push(loadPacman().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Pacman";
  return m;
}));

//server
modelPromises.push(loadServer().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "AI local llm - server";
  return m;
}));
/*
// Mazinga 2
modelPromises.push(loadMazinga2().then(m => {
  m.position.x += 0.4;
  m.userData.interactive = true;
  m.userData.tooltipText = "Mazinga Z";
  return m;
}));
*/
/*
// Daitan 3
modelPromises.push(loadDaitan3().then(m => {
  m.position.x += 0.8;
  m.userData.interactive = true;
  m.userData.tooltipText = "Daitan 3";
  return m;
}));
*/
/*
// Goldrake
modelPromises.push(loadGoldrake().then(m => {
  m.position.x += 1.2;
  m.userData.interactive = true;
  m.userData.tooltipText = "Goldrake";
  return m;
}));
*/
/*
// Jeeg
modelPromises.push(loadJeeg().then(m => {
  m.position.x += 1.6;
  m.userData.interactive = true;
  m.userData.tooltipText = "Jeeg Robot";
  return m;
}));
*/
// Ken
/*
modelPromises.push(loadKen().then(m => {
  m.position.x += 2.0;
  m.userData.interactive = true;
  m.userData.tooltipText = "Ken";
  return m;
}));
*/

// Ryu
/*
modelPromises.push(loadRyu().then(m => {
  m.position.x += 2.4;
  m.userData.interactive = true;
  m.userData.tooltipText = "Ryu";
  return m;
}));
*/

// Bronzi
/*
modelPromises.push(loadBronzi().then(m => {
  m.position.x += 2.8;
  m.userData.interactive = true;
  m.userData.tooltipText = "Bronzi di Riace";
  return m;
}));
*/

//coffeemachine
modelPromises.push(loadCoffeeMachine().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Professional Coffee Machine";
  return m;
}));

//drone
modelPromises.push(loadDrone().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Security Drone";
  return m;
}));

//aroundweb
modelPromises.push(loadAroundWeb().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "AroundWeb";
  return m;
}));

//memes
modelPromises.push(loadMemes());

//android
//modelPromises.push(loadAndroid());

//switch2
modelPromises.push(loadSwitch2().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Switch 2";
  return m;
}));

//nas
modelPromises.push(loadNas().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Nas";
  return m;
}));

//sonic
modelPromises.push(loadSonic().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Sonic";
  return m;
}));

//screen
modelPromises.push(loadScreen());

//stand
modelPromises.push(loadStand());

//door
modelPromises.push(loadDoor());

//world
//modelPromises.push(loadWorld());

//shelf
modelPromises.push(loadShelf());

// real-time clock
modelPromises.push(loadRealClock());

//keyboard
modelPromises.push(loadKeyboard().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Keyboard";
  return m;
}));
modelPromises.push(loadKeyboard2().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Broken keyboard";
  return m;
}));

//motherboard
//modelPromises.push(loadMotherboard());

//frontWall
modelPromises.push(loadFrontWall());
modelPromises.push(loadFrontWallSx());
modelPromises.push(loadFrontWallDx());

//backWall
modelPromises.push(loadBackWall());

//roof
modelPromises.push(loadRoof());

//city
modelPromises.push(loadCity());

//glass
modelPromises.push(loadGlass());

//codeWall
modelPromises.push(loadCodeWall1());
//modelPromises.push(loadCodeWall1b());
//modelPromises.push(loadCodeWall2());
//modelPromises.push(loadCodeWall3());
//modelPromises.push(loadCodeWall4());
modelPromises.push(loadCodeWall5());
modelPromises.push(loadCodeWall6());

//fan
modelPromises.push(loadFan());

//db logo
modelPromises.push(loadDbLogo());

//db logo png white
modelPromises.push(loadDbLogoPngWhite());

//db logo png
modelPromises.push(loadDbLogoPng());

//java
modelPromises.push(loadJava().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Java";
  return m;
}));

//skills
modelPromises.push(loadSkills());

//pc
//modelPromises.push(loadPc());
modelPromises.push(loadPcPersonal().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Development PC";
  return m;
}));

//beam
//modelPromises.push(loadBeam());

//notebook
modelPromises.push(loadNotebook().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Notebook";
  return m;
}));

//screenNotebook
modelPromises.push(loadScreenNotebook());

//shelf_af
modelPromises.push(loadShelfAf());

//smartphone
modelPromises.push(loadSmartphone().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Smartphone";
  return m;
}));

//paint1
modelPromises.push(loadPaint1());

//paint2
modelPromises.push(loadPaint2());

//paint3
modelPromises.push(loadPaint3());

//paint4
modelPromises.push(loadPaint4());

//tvstand
modelPromises.push(loadTv().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "TV";
  return m;
}));

//xbox
modelPromises.push(loadXbox().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Xbox One X";
  return m;
}));

//seriesx
modelPromises.push(loadSeriesX().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Xbox Series X";
  return m;
}));

//switch
modelPromises.push(loadSwitch().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Switch";
  return m;
}));

//neon
modelPromises.push(loadNeon());

//coffee
modelPromises.push(loadCoffee().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Coffee";
  return m;
}));

const Fan = new THREE.Group();

//elix
modelPromises.push(loadElix());

//sky
modelPromises.push(loadSky());

//asphalt
//modelPromises.push(loadAsphalt());

//floor
//modelPromises.push(loadFloor());

///////////////////////////////////////////////////////

//tapisRoulant
modelPromises.push(loadTapisRoulant().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Tapis Roulant";
  return m;
}));

//task
modelPromises.push(loadTask());

//coding
modelPromises.push(loadCoding().then(m => {
  m.userData.interactive = true;
  m.userData.tooltipText = "Coding for dummies";
  return m;
}));

function updateSetButtons() {
  const buttons = document.querySelectorAll("[data-scene-set]");
  buttons.forEach((button) => {
    if (button.dataset.sceneSet === currentSet) {
      button.classList.add("active");
    } else {
      button.classList.remove("active");
    }
  });
}

function applySceneSet(name) {
  const config = sceneSets[name];
  if (
    !config ||
    !lightPrimary ||
    !lightFill ||
    !lightRim ||
    !lightBounce
  ) {
    return;
  }

  scene.background = new THREE.Color(config.background);
  scene.fog = new THREE.Fog(config.fog.color, config.fog.near, config.fog.far);

  lightPrimary.color = new THREE.Color(config.lights.primary.color);
  const bloomLightBoost = bloomEnabled ? 1.18 : 1;

  lightPrimary.intensity = config.lights.primary.intensity * brightnessLevel * bloomLightBoost;
  lightFill.color = new THREE.Color(config.lights.fill.color);
  lightFill.intensity = config.lights.fill.intensity * brightnessLevel * bloomLightBoost;
  lightRim.color = new THREE.Color(config.lights.rim.color);
  lightRim.intensity = config.lights.rim.intensity * brightnessLevel * bloomLightBoost;
  lightBounce.color = new THREE.Color(config.lights.bounce.color);
  lightBounce.intensity = config.lights.bounce.intensity * brightnessLevel * bloomLightBoost;

  currentSet = name;
  updateSetButtons();
}

function setBrightness(value, updateStorage = false) {
  const clamped = Math.min(1.4, Math.max(0.6, value));
  brightnessLevel = clamped;
  if (updateStorage) {
    localStorage.setItem("sceneBrightness", clamped);
  }
  const brightnessValueEl = document.getElementById("brightnessValue");
  if (brightnessValueEl) {
    brightnessValueEl.textContent = `${Math.round(clamped * 100)}%`;
  }
  if (renderer) {
    const bloomToneBoost = bloomEnabled ? 1.2 : 1;
    renderer.toneMappingExposure = clamped * bloomToneBoost;
  }
  applySceneSet(currentSet);
}

function bindUi() {
  const setButtons = document.querySelectorAll("[data-scene-set]");
  setButtons.forEach((button) => {
    button.addEventListener("click", () => {
      applySceneSet(button.dataset.sceneSet);
    });
  });
  updateSetButtons();

  const fpsToggle = document.getElementById("fpsToggle");
  if (fpsToggle) {
    fpsToggle.addEventListener("click", () => {
      if (isFpsMode()) {
        disableFpsMode();
      } else {
        enableFpsMode();
      }
    });
    const fpsGuide = document.getElementById("fpsGuide");
    document.addEventListener("pointerlockchange", () => {
      const isLocked = document.pointerLockElement !== null;
      if (isLocked) {
        fpsToggle.classList.add("active");
        if (fpsGuide) fpsGuide.classList.add("active");
        controls.enabled = false;
      } else {
        fpsToggle.classList.remove("active");
        if (fpsGuide) fpsGuide.classList.remove("active");
        // No need to call disableFpsMode() here if it's already triggered by ESC or button
        // Just ensure OrbitControls are back
        controls.enabled = true;
      }
    });
  }

  const modeBar = document.getElementById("modeBar");
  const vrToggle = document.getElementById("vrToggle");
  if (modeBar && vrToggle) {
    modeBar.appendChild(vrToggle);
    vrToggle.addEventListener("click", async () => {
      if (!navigator.xr) {
        alert("Modalità VR non disponibile su questo dispositivo.");
        return;
      }
      try {
        vrToggle.classList.add("active");
        vrToggle.querySelector(".modeLabel").textContent = "Avvio VR...";
        const session = await navigator.xr.requestSession("immersive-vr", {
          optionalFeatures: ["local-floor", "bounded-floor"],
        });
        vrSession = session;
        renderer.xr.setSession(session);
        initVrControllers();
        vrToggle.querySelector(".modeLabel").textContent = "Modalità VR";
        session.addEventListener("end", () => {
          vrToggle.classList.remove("active");
          vrToggle.querySelector(".modeLabel").textContent = "Modalità VR";
        });
      } catch (err) {
        vrToggle.classList.remove("active");
        vrToggle.querySelector(".modeLabel").textContent = "Modalità VR";
        alert("Nessun visore trovato o VR non disponibile.");
      }
    });
  }

  const brightnessSlider = document.getElementById("brightnessSlider");
  if (brightnessSlider) {
    brightnessSlider.value = brightnessLevel;
    brightnessSlider.addEventListener("input", (event) => {
      const newValue = parseFloat(event.target.value);
      setBrightness(newValue, true);
    });
  }

  setBrightness(brightnessLevel, false);
}

init();
bindUi();

if (startTimeline) {
  StartTimeline();
}

Promise.all(modelPromises)
  .then(() => {
    console.log("Models loaded");
    document.querySelector("div.webglHover").style.display = "none";

    // Initialize interaction system
    initInteractions(camera, scene, renderer);
  })
  .catch((err) => {
    console.log(err);
  });
/*
window.myApp = {
  renderer: renderer,
};
*/

function init() {
  renderer = initialRenderer;
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.xr.enabled = true;
  const bloomToneBoost = bloomEnabled ? 1.2 : 1;
  renderer.toneMappingExposure = brightnessLevel * bloomToneBoost;
  scene.background = new THREE.Color(sceneSets[currentSet].background);
  scene.fog = new THREE.Fog(
    sceneSets[currentSet].fog.color,
    sceneSets[currentSet].fog.near,
    sceneSets[currentSet].fog.far
  );

  //renderer.outputEncoding = THREE.sRGBEncoding;
  //renderer.outputEncoding = THREE.LinearEncoding;
  //renderer.outputEncoding = THREE.GammaEncoding;
  //renderer.outputEncoding = THREE.RGBEEncoding;
  //renderer.outputEncoding = THREE.LogLuvEncoding;
  //renderer.physicallyCorrectLights = true;

  document.body.appendChild(renderer.domElement);

  //light 1
  const lightContainerGeometry = new THREE.BoxGeometry(1, 1, 1);
  const lightContainerMaterial = new THREE.MeshBasicMaterial({
    color: 0xcdcdcd,
  });
  const lightContainer = new THREE.Mesh(
    lightContainerGeometry,
    lightContainerMaterial
  );
  lightContainer.position.set(
    -2.3615650600385356,
    3.2119737851728565,
    4.497990270406487
  );
  lightContainer.rotation.set(
    1.7800172146832778,
    -1.2549971047050765,
    -2.1300213748784094
  );

  const lightContainerMaterialB = new THREE.MeshPhysicalMaterial({
    transparent: true,
    opacity: 0,
  });

  lightContainer.material = lightContainerMaterialB;
  scene.add(lightContainer);

  const lightContainerGeometryt = new THREE.BoxGeometry(1, 1, 1);
  const lightContainerMaterialt = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0,
  });
  const lightTarget = new THREE.Mesh(
    lightContainerGeometryt,
    lightContainerMaterialt
  );
  lightTarget.position.set(
    -2.6142609827063943,
    1.6032648172729573,
    -2.344707021496216
  );
  lightTarget.rotation.set(
    1.7800172146832778,
    -1.2549971047050765,
    -2.1300213748784094
  );
  scene.add(lightTarget);

  lightPrimary = new THREE.DirectionalLight(0x999999);
  lightPrimary.position.set(0, 0, 0);
  lightPrimary.castShadow = true;
  lightPrimary.intensity = 4;

  lightPrimary.shadow.enabled = true;
  lightPrimary.shadow.mapSize.width = 1024;
  lightPrimary.shadow.mapSize.height = 1024;
  lightPrimary.shadow.bias = 0.0005;
  lightPrimary.shadow.normalBias = 0.1;
  lightPrimary.shadow.camera.near = 0.1;
  lightPrimary.shadow.camera.far = 30;
  lightPrimary.shadow.camera.left = -12;
  lightPrimary.shadow.camera.right = 12;
  lightPrimary.shadow.camera.top = 12;
  lightPrimary.shadow.camera.bottom = -12;
  scene.add(lightPrimary);

  //Floor
  const parquet = texture_loader.load("./office/textures/parquet.jpg");
  parquet.encoding = THREE.sRGBEncoding;
  parquet.anisotropy = renderer.capabilities.getMaxAnisotropy();
  var floorGeometry = new THREE.PlaneGeometry(2, 2);
  var floorMaterial = new THREE.MeshStandardMaterial({
    map: parquet,
    roughness: 0.62,
    metalness: 0.08,
  });
  var floor = new THREE.Mesh(floorGeometry, floorMaterial);
  floor.receiveShadow = true;
  parquet.wrapS = THREE.RepeatWrapping;
  parquet.wrapT = THREE.RepeatWrapping;
  parquet.magFilter = THREE.LinearFilter;
  parquet.minFilter = THREE.LinearMipmapLinearFilter;
  parquet.repeat.set(8, 4);
  floorMaterial.receiveShadow = true;
  scene.add(floor);
  floor.scale.x = 7.8;
  floor.scale.y = 3.8;
  floor.position.set(0, 0.5698188312331918, 6.581996091425584);
  floor.rotation.set(-1.5628952655007182, 0, 0);

  /*
  const floorReflector = new Reflector(floorGeometry, {
    clipBias: 0.003,
    textureWidth: window.innerWidth * window.devicePixelRatio,
    textureHeight: window.innerHeight * window.devicePixelRatio,
    color: 0x888888
});
  floorReflector.rotation.x = -Math.PI / 2;
  scene.add(floorReflector);
*/

  //ControlFunction(floor);
  //end floor

  ///////////////////////////////////

  lightContainer.add(lightPrimary);
  lightPrimary.target = lightTarget;
  //ControlFunction(lightTarget);
  //ControlFunction(lightContainer);

  lightPrimary.lookAt(floor.position);
  //end light1

  //light2
  const lightContainerGeometry2 = new THREE.BoxGeometry(1, 1, 1);
  const lightContainerMaterial2 = new THREE.MeshBasicMaterial({
    color: 0xffffff,
  });
  const lightContainer2 = new THREE.Mesh(
    lightContainerGeometry2,
    lightContainerMaterial2
  );

  lightContainer2.position.set(
    2.1814686243449376,
    2.0119737851728565,
    2.6872926372793575
  );

  lightContainer2.rotation.set(
    1.7800172146832778,
    1.2549971047050765,
    2.1300213748784094
  );


  /*
  
  lightContainer2.position.set(
    1.1814686243449376,
    1.9119737851728565,
    3.1872926372793575
  );

  lightContainer2.rotation.set(
    1.7800172146832778,
    1.2549971047050765,
    2.1300213748784094
  );
  
  */

  const lightContainerMaterialC = new THREE.MeshPhysicalMaterial({
    transparent: true,
    opacity: 0,
  });

  lightContainer2.material = lightContainerMaterialC;
  scene.add(lightContainer2);
  lightFill = new THREE.DirectionalLight(0xffffff);
  lightFill.position.set(0, 0, 0);
  lightFill.castShadow = true;
  lightFill.intensity = 1.5;
  lightFill.distance = 50;
  lightFill.shadow.mapSize.width = 512;
  lightFill.shadow.mapSize.height = 512;
  lightFill.shadow.camera.near = 0.1;
  lightFill.shadow.camera.far = 30;
  lightFill.shadow.camera.left = -10;
  lightFill.shadow.camera.right = 10;
  lightFill.shadow.camera.top = 10;
  lightFill.shadow.camera.bottom = -10;
  scene.add(lightFill);
  lightContainer2.add(lightFill);

  const lightContainerGeometry2t = new THREE.BoxGeometry(1, 1, 1);
  const lightContainerMaterial2t = new THREE.MeshBasicMaterial({
    color: 0x999999,
  });
  const light2Target = new THREE.Mesh(
    lightContainerGeometry2t,
    lightContainerMaterial2t
  );
  light2Target.position.set(
    1.2397613209875253,
    0.00507372351578934,
    2.6839062581295945
  );
  /*
   light2Target.position.set(
    1.2397613209875253,
    0.00507372351578934,
    2.6839062581295945
  );
  */
  light2Target.rotation.set(
    1.5800172146832778,
    -1.2549971047050765,
    -2.1300213748784094
  );

  const lightTargetMaterial = new THREE.MeshPhysicalMaterial({
    transparent: true,
    opacity: 0,
  });

  light2Target.material = lightTargetMaterial;
  scene.add(light2Target);
  lightFill.target = light2Target;
  //ControlFunction(lightContainer2);
  //ControlFunction(light2Target);
  //end light2

  //light3
  const lightContainerGeometry3 = new THREE.BoxGeometry(1, 1, 1);
  const lightContainerMaterial3 = new THREE.MeshBasicMaterial({
    color: 0x000000,
  });
  const lightContainer3 = new THREE.Mesh(
    lightContainerGeometry3,
    lightContainerMaterial3
  );
  lightContainer3.position.set(
    2.3581612556219342,
    4.2119737851728565,
    4.497990270406487
  );
  lightContainer3.rotation.set(
    1.7800172146832778,
    -1.2549971047050765,
    -2.1300213748784094
  );

  const lightContainerMaterialC3 = new THREE.MeshPhysicalMaterial({
    transparent: true,
    opacity: 0,
  });

  lightContainer3.material = lightContainerMaterialC3;
  scene.add(lightContainer3);
  lightRim = new THREE.DirectionalLight(0xffffff);
  lightRim.position.set(0, 0, 0);
  lightRim.castShadow = true;
  lightRim.intensity = 2;
  lightRim.shadow.mapSize.width = 512;
  lightRim.shadow.mapSize.height = 512;
  lightRim.shadow.camera.near = 0.1;
  lightRim.shadow.camera.far = 30;
  lightRim.shadow.camera.left = -10;
  lightRim.shadow.camera.right = 10;
  lightRim.shadow.camera.top = 10;
  lightRim.shadow.camera.bottom = -10;
  scene.add(lightRim);
  lightContainer3.add(lightRim);

  const lightContainerGeometry3t = new THREE.BoxGeometry(1, 1, 1);
  const lightContainerMaterial3t = new THREE.MeshBasicMaterial({
    color: 0x999999,
  });
  const light3Target = new THREE.Mesh(
    lightContainerGeometry3t,
    lightContainerMaterial3t
  );
  light3Target.position.set(
    3.9940844277753516,
    5.8726592163331047,
    8.248717817819486
  );
  light3Target.rotation.set(
    1.7800172146832778,
    -1.2549971047050765,
    -2.1300213748784094
  );

  const lightTargetMaterial3 = new THREE.MeshPhysicalMaterial({
    transparent: true,
    opacity: 0,
  });

  light3Target.material = lightTargetMaterial3;
  scene.add(light3Target);
  lightRim.target = light3Target;
  //ControlFunction(lightContainer3);
  //ControlFunction(light3Target);
  //end light3












  //light4
  const lightContainerGeometry4 = new THREE.BoxGeometry(1, 1, 1);
  const lightContainerMaterial4 = new THREE.MeshBasicMaterial({
    color: 0x000000,
  });
  const lightContainer4 = new THREE.Mesh(
    lightContainerGeometry4,
    lightContainerMaterial4
  );
  lightContainer4.position.set(
    2.3581612556219342,
    4.2119737851728565,
    4.497990270406487
  );
  lightContainer4.rotation.set(
    1.7800172146832778,
    -1.2549971047050765,
    -2.1300213748784094
  );

  const lightContainerMaterialC4 = new THREE.MeshPhysicalMaterial({
    transparent: true,
    opacity: 0,
  });

  lightContainer4.material = lightContainerMaterialC4;
  scene.add(lightContainer4);
  lightBounce = new THREE.DirectionalLight(0xffffff);
  lightBounce.position.set(0, 0, 0);
  lightBounce.castShadow = false;
  lightBounce.intensity = 3;
  scene.add(lightBounce);
  lightContainer4.add(lightBounce);

  const lightContainerGeometry4t = new THREE.BoxGeometry(1, 1, 1);
  const lightContainerMaterial4t = new THREE.MeshBasicMaterial({
    color: 0x999999,
  });
  const light4Target = new THREE.Mesh(
    lightContainerGeometry4t,
    lightContainerMaterial4t
  );
  light4Target.position.set(
    0.9940844277753516,
    5.8726592163331047,
    8.248717817819486
  );
  light4Target.rotation.set(
    1.7800172146832778,
    -1.2549971047050765,
    -2.1300213748784094
  );

  const lightTargetMaterial4 = new THREE.MeshPhysicalMaterial({
    transparent: true,
    opacity: 0,
  });

  light4Target.material = lightTargetMaterial4;
  scene.add(light4Target);
  lightBounce.target = light4Target;
  //ControlFunction(lightContainer4);
  //ControlFunction(light4Target);
  //end light4

  // Shelf / Collectibles Lighting - Simplified
  const lightAmbient = new THREE.AmbientLight(0xffffff, 0.8); // Higher ambient for better visibility
  scene.add(lightAmbient);

  // lightShelf Visualizer (optional, keep commented)
  // const spotLightHelper = new THREE.SpotLightHelper(lightShelf);
  // scene.add(spotLightHelper);

  applySceneSet(currentSet);

  if (startKeysCamera) {
    keysCamera();
  }
  initJoysticks();
}

const sizes = {
  width: 800,
  height: 600,
};

window.addEventListener("resize", () => {
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();
  renderer.setSize(sizes.width, sizes.height);
});
